import controller from './authorise.controller';
import template from './authorise.pug';

const AuthoriseComponent = {
  template,
  controller,
};

export default AuthoriseComponent;



// WEBPACK FOOTER //
// ./client/app/authorise/authorise.component.js